"use strict";

var _slicedToArray = require("/codebuild/output/src2429405957/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _formik = require("formik");
var yup = _interopRequireWildcard(require("yup"));
var _colors = require("../config/colors.config");
var _contactUsIcon = _interopRequireDefault(require("../assets/img/contactUsIcon"));
var _fontPloni = require("../config/font.ploni.config");
var _validation = require("./utils/validation");
var _helpers = require("./utils/helpers");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Coffee = (0, _helpers.getImageByAgent)('coffee.svg');
var Alert = (0, _helpers.getImageByAgent)('alert.svg');
var agentDeveloperName = _helpers.agentDeveloperUtils.getAgentDeveloperName;
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    alert: {
      backgroundImage: "url(".concat(Alert, ")"),
      display: 'inline-flex',
      height: '71px',
      margin: '51px 100px 0px 94px',
      width: '79px'
    },
    bottomStaticContainer: {
      background: theme.palette.background.default,
      borderRadius: '0 0 20px 20px'
    },
    bottomStaticDivider: {
      backgroundColor: theme.palette.background.paper,
      marginBottom: 6,
      padding: '28px 0 0 0'
    },
    bottomStaticListContainer: {
      backgroundColor: theme.palette.background.default,
      marginBottom: 6,
      padding: '26px 22px 0 18px'
    },
    bottomStaticPlaceholder: {
      margin: '12px 0 0 0',
      padding: '0 19px 0 15px'
    },
    checkboxLabel: {
      '& a': {
        fontSize: theme.typography.pxToRem(14),
        fontWeight: 'normal',
        lineHeight: 1.2
      },
      fontSize: theme.typography.pxToRem(14),
      fontWeight: 'normal',
      lineHeight: 1.2,
      paddingTop: 8,
      textAlign: 'left'
    },
    coffee: {
      backgroundImage: "url(".concat(Coffee, ")"),
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      display: 'inline-flex',
      height: '107px',
      margin: '68px 95px 0px 95px',
      width: '85px'
    },
    contact24: {
      display: 'inline-flex',
      height: '45px',
      margin: '28px 0 20px 122px',
      width: '125px'
    },
    errorHeader: {
      color: theme.palette.primary.main,
      display: 'inline-flex',
      fontWeight: 'bold',
      height: '33px',
      margin: '17px 0 10px 0',
      opacity: '1'
    },
    errorText: {
      display: 'inline-flex',
      height: '52px',
      letterSpacing: '0.5px',
      margin: '0 50px 10px 49px',
      opacity: '1'
    },
    gridItemPadding: {
      '& .MuiFormHelperText-root': {
        '&:last-child': {
          margin: '0 14px 0'
        },
        height: theme.typography.pxToRem(16)
      },
      '&:nth-of-type(2), &:nth-of-type(3)': {
        marginBottom: 6
      },
      marginBottom: 12,
      padding: '0 19px 0 15px'
    },
    labelPopup: {
      color: theme.palette.secondary.mainLight,
      display: 'inline-table',
      fontSize: '1rem',
      fontWeight: 'bold',
      height: '26px',
      margin: '0 0 0 10px',
      opacity: '1'
    },
    paper: {
      '& .MuiButton-label': {
        height: '18px'
      },
      '& .MuiButton-outlined': {
        fontFamily: _fontPloni.PloniRegular,
        fontSize: theme.typography.pxToRem(15.75),
        fontWeight: 'bold',
        height: '52px',
        width: '100%'
      },
      '& .MuiFormControl-root.MuiTextField-root': {
        '& .MuiFormHelperText-root': {
          margin: '0 14px 0'
        },
        width: '100%'
      },
      '& .MuiGrid-root.MuiGrid-container': {
        '& .MuiOutlinedInput-input': {
          fontWeight: 'bold'
        }
      },
      border: "1px solid ".concat(_colors.Black[90]),
      borderRadius: '20px',
      boxShadow: 'none',
      width: '274px'
    },
    pCircle: {
      background: '#C0D9E3 0% 0% no-repeat padding-box',
      borderRadius: '5px',
      display: 'inline-flex',
      height: '10px',
      opacity: '1',
      width: '10px'
    },
    pRadio: {
      fontSize: '0.85rem',
      letterSpacing: 0,
      margin: '2px 0 15px 20px',
      opacity: '0.64'
    },
    successHeader: {
      color: theme.palette.secondary.main,
      display: 'inline-flex',
      fontWeight: 'bold',
      height: '33px',
      margin: '15px 0 4px 0',
      opacity: '1'
    },
    successText: {
      display: 'inline-flex',
      height: '24px',
      margin: '0 0 57px 0',
      opacity: '1'
    },
    titleAndDotContainer: {
      alignItems: 'baseline',
      display: 'flex'
    }
  };
});
var ContactUs = function ContactUs(props) {
  var postRequest = props.postRequest,
    label = props.label,
    linkText = props.linkText,
    isShowIdInput = props.isShowIdInput;
  var _react$default$useSta = _react.default.useState('block'),
    _react$default$useSta2 = _slicedToArray(_react$default$useSta, 2),
    displayForm = _react$default$useSta2[0],
    setDisplayForm = _react$default$useSta2[1];
  var _react$default$useSta3 = _react.default.useState('none'),
    _react$default$useSta4 = _slicedToArray(_react$default$useSta3, 2),
    displayErrorBlock = _react$default$useSta4[0],
    setDisplayErrorBlock = _react$default$useSta4[1];
  var _react$default$useSta5 = _react.default.useState('none'),
    _react$default$useSta6 = _slicedToArray(_react$default$useSta5, 2),
    displaySuccessBlock = _react$default$useSta6[0],
    setDisplaySuccessBlock = _react$default$useSta6[1];
  var classes = useStyles();
  var bottomStatic = function bottomStatic() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes.bottomStaticContainer
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      className: classes.bottomStaticDivider
    }, /*#__PURE__*/_react.default.createElement("hr", {
      style: {
        border: '1px solid #EEEEEE',
        margin: 0
      }
    })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      className: classes.bottomStaticListContainer
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.titleAndDotContainer
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.pCircle
    }), /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "h2",
      className: classes.labelPopup
    }, "\u05DC\u05E7\u05D5\u05D7\u05D5\u05EA Wobi \u05E0\u05D4\u05E0\u05D9\u05DD \u05D9\u05D5\u05EA\u05E8!")), /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: classes.pRadio
    }, "\u05E0\u05E6\u05D9\u05D2\u05D9\u05E0\u05D5 \u05D9\u05E9\u05DE\u05D7\u05D5 \u05DC\u05E1\u05D9\u05D9\u05E2 \u05DC\u05DB\u05DD \u05D1\u05D8\u05DC\u05E4\u05D5\u05DF \u05D1\u05E8\u05DB\u05D9\u05E9\u05EA \u05D1\u05D9\u05D8\u05D5\u05D7 \u05DE\u05E9\u05EA\u05DC\u05DD \u05D5\u05DE\u05D5\u05EA\u05D0\u05DD \u05E2\u05D1\u05D5\u05E8\u05DB\u05DD"), /*#__PURE__*/_react.default.createElement("div", {
      className: classes.titleAndDotContainer
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.pCircle
    }), /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "h2",
      className: classes.labelPopup
    }, "\u05DE\u05DC\u05D5\u05D5\u05D9\u05DD \u05D0\u05D5\u05EA\u05DA \u05DB\u05DC \u05D4\u05D3\u05E8\u05DA")), /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: classes.pRadio
    }, "\u05DE\u05D1\u05D5\u05D8\u05D7\u05D9 Wobi \u05E0\u05D4\u05E0\u05D9\u05DD \u05DE\u05E9\u05D9\u05E8\u05D5\u05EA \u05E4\u05E8\u05DE\u05D9\u05D5\u05DD \u05DC\u05DB\u05DC \u05D0\u05D5\u05E8\u05DA \u05D4\u05D3\u05E8\u05DA, \u05D4\u05E0\u05D9\u05EA\u05DF \u05E2\u05DC \u05D9\u05D3\u05D9 \u05E0\u05E6\u05D9\u05D2\u05D9\u05DD \u05DE\u05D9\u05D5\u05DE\u05E0\u05D9\u05DD \u05D5\u05DE\u05E7\u05E6\u05D5\u05E2\u05D9\u05D9\u05DD")), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      className: classes.bottomStaticPlaceholder
    }));
  };
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_core.Paper, {
    className: classes.paper
  }, /*#__PURE__*/_react.default.createElement(_formik.Formik, {
    validationSchema: yup.object().shape({
      id: isShowIdInput ? _validation.validIsraeliId : yup.string(),
      name: _validation.fullNameHebrewOnly,
      phone: _validation.validPhone,
      tos: yup.boolean().oneOf([true], 'שדה חובה')
    }),
    onSubmit: function onSubmit(values, _ref) {
      var setSubmitting = _ref.setSubmitting;
      setSubmitting(true);
      // eslint-disable-next-line no-extra-parens
      if (!values.name || !values.phone || !values.tos || isShowIdInput && !values.id) {
        setSubmitting(false);
        setDisplayForm('none');
        setDisplayErrorBlock('block');
      } else {
        postRequest(values).then(function () {
          setDisplayForm('none');
          setDisplaySuccessBlock('block');
        }).catch(function () {
          setSubmitting(false);
          setDisplayForm('none');
          setDisplayErrorBlock('block');
        });
      }
    },
    initialValues: {
      id: '',
      name: '',
      phone: '',
      tos: false
    }
  }, function (_ref2) {
    var errors = _ref2.errors,
      touched = _ref2.touched,
      handleChange = _ref2.handleChange,
      handleBlur = _ref2.handleBlur,
      handleSubmit = _ref2.handleSubmit,
      isSubmitting = _ref2.isSubmitting;
    return /*#__PURE__*/_react.default.createElement(_formik.Form, {
      onSubmit: handleSubmit,
      style: {
        display: displayForm
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.contact24,
      alt: "24 7"
    }, agentDeveloperName === 'Wobi' ? /*#__PURE__*/_react.default.createElement(_contactUsIcon.default, {
      label: "24 7"
    }) : /*#__PURE__*/_react.default.createElement("img", {
      src: (0, _helpers.getImageByAgent)('24-7.svg'),
      alt: "24-7"
    })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true,
      spacing: 0
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      className: classes.gridItemPadding
    }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
      id: 'contact-us-name',
      label: 'שם מלא',
      onChange: handleChange,
      onBlur: handleBlur,
      name: "name",
      error: errors.name && touched.name,
      helperText: /*#__PURE__*/_react.default.createElement(_formik.ErrorMessage, {
        name: 'name'
      })
    })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      className: classes.gridItemPadding
    }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
      id: 'contact-us-phone',
      label: 'טלפון',
      onChange: function onChange(e) {
        e.target.value = e.target.value.replace(/\D/g, '');
        handleChange(e);
      },
      onBlur: handleBlur,
      name: "phone",
      error: errors.phone && touched.phone,
      helperText: /*#__PURE__*/_react.default.createElement(_formik.ErrorMessage, {
        name: 'phone'
      })
    })), isShowIdInput ? /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      className: classes.gridItemPadding
    }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
      id: 'contact-us-id',
      label: 'תעודת זהות',
      onChange: function onChange(e) {
        e.target.value = e.target.value.replace(/\D/g, '');
        handleChange(e);
      },
      onBlur: handleBlur,
      name: "id",
      error: errors.id && touched.id,
      helperText: /*#__PURE__*/_react.default.createElement(_formik.ErrorMessage, {
        name: 'id'
      })
    })) : null, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      className: classes.gridItemPadding
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true,
      wrap: "nowrap"
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true
    }, /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
      id: 'tos',
      inputProps: {
        'aria-label': 'אני מאשר מאשרת את תנאי השימוש ומאשר מאשרת קבלת תוכן פרסומי כאמור בתנאים המפורטים'
      },
      onChange: handleChange,
      onBlur: handleBlur,
      name: "tos"
    })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.checkboxLabel
    }, label + ' ', /*#__PURE__*/_react.default.createElement(_core.Link, {
      href: _helpers.agentDeveloperUtils.getAgentLinks.termsAndConditions,
      target: "_blank"
    }, linkText)))), /*#__PURE__*/_react.default.createElement(_core.FormHelperText, {
      error: true
    }, errors.tos && touched.tos && /*#__PURE__*/_react.default.createElement("span", {
      "aria-label": 'אישור פרטים ' + errors.tos
    }, errors.tos))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      className: classes.gridItemPadding
    }, /*#__PURE__*/_react.default.createElement(_core.Button, {
      disabled: isSubmitting,
      variant: 'outlined',
      type: 'submit',
      "aria-label": Object.keys(errors).length ? 'התקשרו אליי, יש למלא תחילה את כל פרטי הטופס' : null
    }, "\u05D4\u05EA\u05E7\u05E9\u05E8\u05D5 \u05D0\u05DC\u05D9\u05D9")), bottomStatic()));
  }), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: displaySuccessBlock
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.coffee
  }), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h5",
    className: classes.successHeader
  }, "\u05E4\u05E0\u05D9\u05D9\u05EA\u05DA \u05D4\u05EA\u05E7\u05D1\u05DC\u05D4"), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "caption",
    className: classes.successText
  }, "\u05E0\u05E6\u05D9\u05D2 \u05DE\u05DB\u05D9\u05E8\u05D5\u05EA \u05D9\u05D7\u05D6\u05D5\u05E8 \u05D0\u05DC\u05D9\u05DA \u05D1\u05D4\u05E7\u05D3\u05DD")), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 0
  }, bottomStatic())), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: displayErrorBlock
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.alert
  }), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h5",
    className: classes.errorHeader
  }, "\u05D0\u05D5\u05E4\u05E1\u2026"), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "caption",
    className: classes.errorText
  }, "\u05EA\u05E7\u05DC\u05D4 \u05D1\u05E9\u05DC\u05D9\u05D7\u05EA \u05D4\u05E4\u05E8\u05D8\u05D9\u05DD, \u05D1\u05D1\u05E7\u05E9\u05D4 \u05E0\u05E1\u05D5 \u05E9\u05E0\u05D9\u05EA."), /*#__PURE__*/_react.default.createElement(_core.Button, {
    variant: 'outlined',
    onClick: function onClick() {
      setDisplayErrorBlock('none');
      setDisplayForm('block');
    },
    type: 'button',
    style: {
      height: '42px',
      margin: '0 0 18px 0',
      width: '130px'
    }
  }, "\u05D0\u05D9\u05E9\u05D5\u05E8")), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 0
  }, bottomStatic()))));
};
ContactUs.propTypes = {
  isShowIdInput: _propTypes.default.bool,
  label: _propTypes.default.string.isRequired,
  linkText: _propTypes.default.string.isRequired,
  postRequest: _propTypes.default.func
};
var _default = exports.default = ContactUs;